import type { ReactNode } from 'react';
import { Sheet } from '../components/ui/index.js';
import { useHomes } from '../lib/hooks.js';
import { Icon, mdiToIcon } from '../lib/icons.js';
import { switcherOpen, useSwitcherOpen } from '../lib/ui-state.js';
import { useSwitchHome } from './useSwitchHome.js';
import { useMatch, useNavigate } from 'react-router-dom';

export function HomeSwitcher(): ReactNode {
  const open = useSwitcherOpen();
  const homes = useHomes();
  const switchHome = useSwitchHome();
  const navigate = useNavigate();
  const match = useMatch('/h/:home/*');
  const current = match?.params.home;
  const close = (): void => switcherOpen.set(false);
  return (
    <Sheet open={open} onClose={close} title="Homes" desktop="modal" testId="home-switcher">
      <ul className="home-list" role="list">
        {homes.map((h, i) => (
          <li key={h.id}>
            <button
              type="button"
              className="home-row"
              aria-current={h.id === current ? 'true' : undefined}
              data-testid={`switch-${h.id}`}
              onClick={() => {
                close();
                switchHome(h.id);
              }}
            >
              <span className="home-row-icon">
                <Icon name={mdiToIcon(h.icon) ?? 'home'} size={20} />
              </span>
              <span className="home-row-text">
                <strong>{h.name}</strong>
                <span>
                  <span className="dot" data-tone={h.online ? 'positive' : 'alert'} /> {h.online ? h.status ?? 'Online' : 'Offline'}
                </span>
              </span>
              {h.id === current ? <Icon name="check" size={18} /> : <kbd className="kbd">⌘{i + 1}</kbd>}
            </button>
          </li>
        ))}
      </ul>
      <button
        type="button"
        className="link-btn"
        onClick={() => {
          close();
          navigate('/overview');
        }}
      >
        <Icon name="grid" size={15} /> Overview of all homes
      </button>
    </Sheet>
  );
}
